import React, { useEffect, useState } from 'react';
import { Button, Form, Card, Row, Col } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import {
  createTouristCenter,
  getTouristCenters,
  updateTouristCenter,
  deleteTouristCenter,
} from '../../API/touristCenterApi'; // Adjust the import path as necessary
import './TouristInfo.css';

export default function TouristInfoCenter() {
  const [placeName, setPlaceName] = useState('');
  const [description, setDescription] = useState('');
  const [contactPerson, setContactPerson] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [touristCenters, setTouristCenters] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);

  useEffect(() => {
    fetchTouristCenters();
  }, []);

  const fetchTouristCenters = async () => {
    try {
      const centers = await getTouristCenters();
      setTouristCenters(centers);
    } catch (error) {
      console.error('Failed to fetch tourist centers:', error.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newCenter = { placeName, description, contactPerson, phoneNumber };

    if (editingIndex !== null) {
      // Update existing center
      const centerToUpdate = touristCenters[editingIndex];
      await updateTouristCenter(centerToUpdate._id, newCenter);
    } else {
      // Create new center
      await createTouristCenter(newCenter);
    }

    // Clear form fields and reset editing index
    resetForm();
    fetchTouristCenters(); // Refresh the list
  };

  const handleDelete = async (id) => {
    try {
      await deleteTouristCenter(id);
      fetchTouristCenters(); // Refresh the list
    } catch (error) {
      console.error('Failed to delete tourist center:', error.message);
    }
  };

  const resetForm = () => {
    setPlaceName('');
    setDescription('');
    setContactPerson('');
    setPhoneNumber('');
    setEditingIndex(null);
  };

  const handleEdit = (index) => {
    const center = touristCenters[index];
    setPlaceName(center.placeName);
    setDescription(center.description);
    setContactPerson(center.contactPerson);
    setPhoneNumber(center.phoneNumber);
    setEditingIndex(index);
  };

  return (
    <div className="container mt-3">
      <h3 className="text-center mb-5">Tourist Information Center</h3>
      <Row>
        {/* Left Form Section */}
        <Col md={5} className="shadow-box">
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Place Name</Form.Label>
              <Form.Control
                type="text"
                value={placeName}
                onChange={(e) => setPlaceName(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Contact Person Name</Form.Label>
              <Form.Control
                type="text"
                value={contactPerson}
                onChange={(e) => setContactPerson(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
            </Form.Group>

            <Button type="submit" className="w-100 addcenter">
              {editingIndex !== null ? 'Update' : 'Submit'}
            </Button>
          </Form>
        </Col>

      {/* Right List Section */}
        <Col md={7}>
          <h5 className="text-center mt-4 ml-5">List Of Tourist Information Center</h5>
          <div 
            className="list-container" 
            style={{ maxHeight: '400px', overflowY: 'auto' }} // Set maxHeight and overflow
          >
            {touristCenters.length === 0 ? (
              <p className="text-center">No data available</p>
            ) : (
              touristCenters.map((center, index) => (
                <Card key={index} className="mb-2">
                  <Card.Body>
                    <Card.Title>{center.placeName}</Card.Title>
                    <Card.Text>{center.description}</Card.Text>
                    <p><strong>Person Name:</strong> {center.contactPerson}</p>
                    <div className="d-flex justify-content-end">
                      <Button
                        variant="outline-success"
                        className="me-2"
                        onClick={() => handleEdit(index)}
                      >
                        <FaEdit />
                      </Button>
                      <Button
                        variant="outline-danger"
                        onClick={() => handleDelete(center._id)}
                      >
                        <FaTrash />
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              ))
            )}
          </div>
        </Col>

      </Row>
    </div>
  );
}